// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1PharmacyBiDefaultResponseData {
    static getAttributeTypeMap() {
        return PharmacyV1PharmacyBiDefaultResponseData.attributeTypeMap;
    }
}
PharmacyV1PharmacyBiDefaultResponseData.discriminator = undefined;
PharmacyV1PharmacyBiDefaultResponseData.additionalProperties = false;
PharmacyV1PharmacyBiDefaultResponseData.attributeTypeMap = [
    {
        "name": "plans",
        "baseName": "plans",
        "type": ""
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
    {
        "name": "customerId",
        "baseName": "customerId",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyV1PharmacyBiDefaultResponseData.js.map